import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentInner } from '../../../layout/Content'
import POListInnerStyle from './css/POListInnerStyle'
import POItemController from '../poitem/POItemController'
import { poListControllerContext } from '../polist/POListController'
import { appContext } from '../../../../App'

function POListInner() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const poListController = useContext(poListControllerContext)
  const { poList, sortPOListBy, poListSorted, addSelectedPOId, removeSelectedPOId, foundUnpostedPO } = poListController
  const [selectAll, setSelectAll] = poListController.selectAll
  const startSlice = poListController.startSlice[0]
  const endSlice = poListController.endSlice[0]
  const [sortBy, setSortBy] = poListController.sortBy

  const onClickListItem = (e) => {
    if (e.target.type === 'checkbox') return
    const po_id= e.target.closest('.po-item').id
    const poItem = poList.find(item => item._id === po_id)
    setContent(<POItemController poItem={poItem}/>)
  }

  const onClickSelectAll = (e) =>  { setSelectAll(!selectAll) }

  const onClickSort = (e) => {
    const header = e.target.closest('.title-header')
    sortPOListBy(header.id)
    setSortBy(header.id)
  }

  const onClickCheckBox = (e) => {
    const po_id = e.target.closest('.po-item').id
    const checked = e.target.checked
    if (checked) addSelectedPOId(po_id)
    else removeSelectedPOId(po_id)
  }

  return (
    <ContentInner>
      <div className='table-po-container'>
        <table className="table striped-table">
          <thead>
            <tr>
              <th>
                <div
                  id='date_prepared'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Date Prepared</div>
                  <span>
                    {
                      (sortBy === 'date_prepared') ?
                        (poListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='po_id'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>P.O. ID</div>
                  <span>
                    {
                      (sortBy === 'po_id') ?
                        (poListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='supplier'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Supplier</div>
                  <span>
                    {
                      (sortBy === 'supplier') ?
                        (poListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='prepared_by'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Prepared By</div>
                  <span>
                    {
                      (sortBy === 'prepared_by') ?
                        (poListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='reference_code'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Reference</div>
                  <span>
                    {
                      (sortBy === 'reference_code') ?
                        (poListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='status'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Status</div>
                  <span>
                    {
                      (sortBy === 'status') ?
                        (poListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th className='empty-header' style={{ display: (foundUnpostedPO) ? 'flex' : 'none', paddingTop: '18px' } }>
                <button
                  type="button"
                  className='pospro-action-btn toolbar-btn'
                  id="select-all-btn"
                  title="Select/Unselect all selectable items on the list"
                  onClick={onClickSelectAll}>
                  {
                    (selectAll) ? (<span style={{fontSize: '1rem' }}><FontAwesomeIcon icon='check-square'/></span>)
                    : (<span style={{fontSize: '1rem'}}><FontAwesomeIcon icon='square'/></span>)
                  }
                </button>
              </th>
            </tr>
          </thead>
          {
            poList.slice(startSlice, endSlice).map((po, index) => (
              <tbody key={po._id} id={index}>
                <tr className='po-item' onClick={onClickListItem} id={po._id}>
                  <td>{new Date(po.date_prepared).toLocaleString("en-us", { timeZone: po.client_timezone }).split(',')[0]} { po.client_timezone }</td>
                  <td>{po._id.toUpperCase()}</td>
                  <td>{po.supplier}</td>
                  <td>{po.prepared_by}</td>
                  <td>{po.reference_code}</td>
                  <td><span className={(po.status === 'Unposted') ? 'status-red' : 'status-blue'}>{po.status}</span></td>
                  {
                    (foundUnpostedPO)
                    ? <td>{
                        (po.status === 'Unposted')
                        ? <input type='checkbox' onClick={onClickCheckBox} className='po-checkbox'/>
                        : ''
                      }</td>
                    : null
                  }
                </tr>
              </tbody>
            ))
          }
        </table>
      </div>
      <POListInnerStyle />
    </ContentInner>
  )
}

export default React.memo(POListInner)